var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorCircleOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93 4.93a9.97 9.97 0 0114.14 0 9.97 9.97 0 010 14.14 9.97 9.97 0 01-14.14 0 9.97 9.97 0 010-14.14zM12 3.8A8.17 8.17 0 003.8 12a8.17 8.17 0 008.2 8.2 8.17 8.17 0 008.2-8.2A8.17 8.17 0 0012 3.8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7c.5 0 .9.4.9.9v5.2a.9.9 0 01-1.8 0V7.9c0-.5.4-.9.9-.9z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjkzIDQuOTNhOS45NyA5Ljk3IDAgMCAxIDE0LjE0IDAgOS45NyA5Ljk3IDAgMCAxIDAgMTQuMTQgOS45NyA5Ljk3IDAgMCAxLTE0LjE0IDAgOS45NyA5Ljk3IDAgMCAxIDAtMTQuMTRaTTEyIDMuOEE4LjE3IDguMTcgMCAwIDAgMy44IDEyYTguMTcgOC4xNyAwIDAgMCA4LjIgOC4yIDguMTcgOC4xNyAwIDAgMCA4LjItOC4yQTguMTcgOC4xNyAwIDAgMCAxMiAzLjhaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMTMgMTZhMSAxIDAgMSAxLTIgMCAxIDEgMCAwIDEgMiAwWiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA3Yy41IDAgLjkuNC45Ljl2NS4yYS45LjkgMCAwIDEtMS44IDBWNy45YzAtLjUuNC0uOS45LS45WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+Cg==";
export { SvgErrorCircleOutline24 as ReactComponent };